module.exports = __webpack_public_path__ + "static/media/6_School of the animals_UAE.57d4c86c.txt";